import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { MessageCategoryComponent } from './message-category';

@NgModule({
    declarations: [
        MessageCategoryComponent,
    ],
    imports: [
        IonicPageModule.forChild(MessageCategoryComponent),
    ],
    exports: [
        MessageCategoryComponent
    ],
    entryComponents: [
        
    ]
})
export class MessageCategoryComponentModule { }



// WEBPACK FOOTER //
// ./src/components/message-category/message-category.module.ts